import Loyalty from './Loyalty.view';

export default Loyalty;
